module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "m_context plr"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "12.5%"
    }
  }, [_c('el-popover', {
    ref: "popover1",
    attrs: {
      "placement": "bottom-start",
      "trigger": "hover",
      "content": _vm.$t('terminal.add.popover_no'),
      "popper-class": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_no'),
      "prop": "terminal_no"
    }
  }, [_c('el-input', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover1",
      arg: "popover1"
    }],
    attrs: {
      "id": "terminal_no",
      "maxlength": 50,
      "placeholder": _vm.$t('terminal.add.place_no')
    },
    model: {
      value: (_vm.form.terminal_no),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminal_no", $$v)
      },
      expression: "form.terminal_no"
    }
  })], 1), _vm._v(" "), _c('el-popover', {
    ref: "popover2",
    attrs: {
      "placement": "bottom-start",
      "trigger": "hover",
      "content": _vm.$t('terminal.add.popover_name'),
      "popper-class": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_name'),
      "prop": "terminal_name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover2",
      arg: "popover2"
    }],
    attrs: {
      "id": "terminal_name",
      "maxlength": 50,
      "placeholder": _vm.$t('terminal.add.place_name')
    },
    model: {
      value: (_vm.form.terminal_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminal_name", $$v)
      },
      expression: "form.terminal_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_areaid'),
      "prop": "areaid"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "cclasss": "'w_33'"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_model'),
      "prop": "terminal_model"
    }
  }, [_c('el-select', {
    staticClass: "w_33",
    attrs: {
      "disabled": !_vm.form.areaid,
      "id": "terminal_model",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_model')
    },
    model: {
      value: (_vm.form.terminal_model),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminal_model", $$v)
      },
      expression: "form.terminal_model"
    }
  }, _vm._l((_vm.models), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_type'),
      "prop": "terminal_type"
    }
  }, [_c('el-select', {
    staticClass: "w_33",
    attrs: {
      "disabled": !_vm.form.areaid,
      "id": "terminal_type",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_type')
    },
    model: {
      value: (_vm.form.terminal_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminal_type", $$v)
      },
      expression: "form.terminal_type"
    }
  }, _vm._l((_vm.dvTypes), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_manufid'),
      "prop": "manufid"
    }
  }, [_c('el-select', {
    staticClass: "w_33",
    attrs: {
      "disabled": !_vm.form.areaid,
      "id": "terminal_type",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_manufid')
    },
    model: {
      value: (_vm.form.manufid),
      callback: function($$v) {
        _vm.$set(_vm.form, "manufid", $$v)
      },
      expression: "form.manufid"
    }
  }, _vm._l((_vm.firms), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_address'),
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "address",
      "placeholder": _vm.$t('terminal.add.place_address')
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.remark'),
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "id": "address",
      "placeholder": _vm.$t('app_input')
    },
    model: {
      value: (_vm.form.memo),
      callback: function($$v) {
        _vm.$set(_vm.form, "memo", $$v)
      },
      expression: "form.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "id": "onCancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmit,
      "id": "onSubmit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_add')))])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cd1d84d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/terminal/add.vue
// module id = 1054
// module chunks = 0